import React from 'react'
import DashboardLayout from './../../components/Admin/DashboardLayout'
import { MDBCol, MDBContainer, MDBRow, MDBSelect } from 'mdb-react-ui-kit'
import AdminApi from './../../api/admin-api/admin-api'
import MessagingWidget from './../../components/messaging/MessagingWidget/MessagingWidget.component'
import MessageEditor from './../../components/messaging/MessageEditor/MessageEditor.component'
import UserProfileService from './../../shared/services/UserProfile.service'

import './DivisionMessages.scss'

class DivisionMessagesPage extends React.Component {
  state = {
    divisionList: [],
    activeDivisionId: UserProfileService.get('u_devision'),
  }

  get canSelectDivision() {
    return (
      UserProfileService.isA('internal-staff') ||
      UserProfileService.isA('internal-admin') ||
      UserProfileService.isA('system-admin')
    )
  }

  #getDivisions = async () => {
    let divisionList = []
    try {
      divisionList = await AdminApi.getDivisions()
    } catch (ex) {
      divisionList = []
      console.error(ex)
    }

    divisionList = divisionList && divisionList.data && divisionList.data.data
    divisionList = Array.isArray(divisionList) ? divisionList : []
    divisionList = divisionList.map(division => ({
      text: `${division.d_name}`,
      value: `${division.id}`,
    }))

    this.setState({ divisionList })
  }

  #setActiveDivision = divisionId => {
    if (!isNaN(parseInt(divisionId)) && parseInt(divisionId) !== parseInt(`${this.state.activeDivisionId}`))
      this.setState({ activeDivisionId: divisionId })
  }

  #renderDivisionDropdown = () => {
    if (!this.canSelectDivision) return <></>

    if (!this.state.divisionList.length) return <span>Loading Divisions ... </span>

    return (
      <MDBSelect
        search
        className='divisions-selector'
        data={this.state.divisionList}
        value={this.state.activeDivisionId != null ? `${this.state.activeDivisionId}` : ''}
        preventFirstSelection
        onValueChange={selected =>
          this.#setActiveDivision(Array.isArray(selected) ? selected[0]?.value : selected?.value)
        }
        label='Divisions'
      />
    )
  }

  componentDidMount() {
    if (this.canSelectDivision) this.#getDivisions()
  }

  render() {
    return (
      <React.Fragment>
        <DashboardLayout>
          <main id='DivisionMessagesPage' className='mainSection pb-5'>
            <MDBContainer fluid className='mt-5'>
              <MDBRow>
                <MDBCol size='12' md='8'>
                  <h2>Division Messages</h2>
                </MDBCol>
                <MDBCol size='12' md='4'>
                  {this.#renderDivisionDropdown()}
                </MDBCol>
              </MDBRow>
              <hr />
            </MDBContainer>
            <MessagingWidget division_id={this.state.activeDivisionId} category='division' headerColor={'sky-blue'} />
            <div style={{ padding: '12px' }}>
              <div className='content-wrapper'>
                <MessageEditor division_id={this.state.activeDivisionId} category='division' />
              </div>
            </div>
          </main>
        </DashboardLayout>
      </React.Fragment>
    )
  }
}

export default DivisionMessagesPage
